/* TTL - keep the announcement bar pinned with the sticky header.
 * Publishes the announcement bar's rendered height as --announcement-height on
 * <html>, which main.css uses for the header's sticky offset and for how far
 * both bars slide when the header hides on scroll-down. Idempotent. */
(() => {
  const root = document.documentElement;
  let observed = null;

  const init = () => {
    const bar = document.querySelector('.cc-announcement');
    if (!bar) { root.style.setProperty('--announcement-height', '0px'); return; }
    if (observed === bar) return;
    observed = bar;
    const set = () => root.style.setProperty('--announcement-height', `${bar.getBoundingClientRect().height}px`);
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(bar);
    window.addEventListener('resize', set, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => { observed = null; init(); });
})();
